module.exports = __webpack_public_path__ + "img/D201506_2.46515412.jpg";